<template>
    <Dialog :dialog="dlg">
        <v-form ref="form" lazy-validation>
            
            <Form>
                <FormRow label="Factuurbedrag" >      
                    <TextControl :model="model" cls="text-right pr-3"><AmountText dusk="inv_total" v-model='model.inv_total' :currency='model.currency'/></TextControl>              
                </FormRow>
                <FormRow label="Openstaand bedrag">                    
                    <TextControl :model="model" cls="text-right pr-3"><AmountText dusk="inv_open" v-model='model.inv_open' :currency='model.currency'/></TextControl>
                </FormRow>
                <FormRow label="Ontvangen betaling">                    
                    <NumberField :model="model" amount dusk="paym_amount" :rules="model.amountMandatoryRules" v-model="model.paym_amount"></NumberField>
                </FormRow>
                <FormRow label="Betaaldatum">                    
                    <DatePicker :model="model" :rules="model.rules.mandatory" v-model='model.paym_date'></DatePicker>
                </FormRow>
                <FormRow label="Opmerking">                    
                    <TextField :model="model" dusk="paym_remark" maxLength="48"  placeholder="Optioneel" v-model="model.paym_remark"></TextField>
                </FormRow>

            </Form>
        </v-form>

    </Dialog>
</template>



<script setup>
    import useModel from '@/models/salesinvoice/payment'
    import Form from '@controls/forms/Form'
    import FormColumn from '@controls/forms/FormColumn'
    import FormRow from '@controls/forms/FormRow'
    import TextField from '@controls/input/TextField'
    import Dialog from '@shared/ui/dialogs/ActionDialog'
    import DatePicker from '@controls/input/DatePicker'
    import NumberField from '@controls/input/NumberField'
    import AmountText from '@controls/text/Amount.vue'
    import TextControl from "@controls/text/Control.vue";

    import { ref } from 'vue'
    import clsDialog from '@cls/clsDialog'

    const form = ref(null); 

    let model = useModel();
    let dlg = ref(
        new clsDialog("salesinvoice_payment", "Betaling", model, [form], {
            icon: 'payment'
        })).value;

    window.dlgpayment = dlg;

</script>
